<template>
  <va-create-layout>
    <stats-form :title="title" :item="item"></stats-form>
  </va-create-layout>
</template>

<script>
export default {
  props: ["title", "item"],
};
</script>
